import { useMemo } from 'react'
import { productRecurrencyState } from '@cannect/services/resources/recurrency/helpers'
import { useEligibility } from '@cannect/services/resources/recurrency/hooks'

const MAX_IDS = 48

// Selo da vitrine: uma chamada de elegibilidade por página (sem preços), só
// com acesso (flag + paciente logado). Produto ausente do mapa = sem selo.
export const useRecurrencyBadges = (productIds: Array<number | string | undefined | null>) => {
  const ids = useMemo(
    () =>
      [...new Set(productIds.map(Number).filter((id) => Number.isInteger(id) && id > 0))]
        .sort((a, b) => a - b)
        .slice(0, MAX_IDS),
    [productIds.join(',')]
  )
  const { data, isError } = useEligibility({ productIds: ids })

  return useMemo(() => {
    const states = new Map<number, 'available' | 'unavailable'>()
    if (!data || isError) return states
    ids.forEach((id) => {
      const state = productRecurrencyState(data, id)
      if (state !== 'hidden') states.set(id, state)
    })
    return states
  }, [data, isError, ids])
}
